import { ApiService } from "src/network/apiService";
import { IApiResponse } from "src/network/models/ApiResponse";
import { IMobileAppModel } from "src/types/models/apiModels";

export class MobileAppListViewModel {
  private apiService: ApiService;

  constructor(accessToken: string) {
    this.apiService = new ApiService({ accessToken: accessToken });
  }

  async fetchList(): Promise<IMobileAppModel[]> {
    const response = await this.apiService.getAsync<any>(
      "/onboard/branding-apps"
    );

    if (response) {
      if (response.scResponse && response.scResponse.code === 2000) {
        return response.scResponse.data;
      }

      return [];
    }

    return [];
  }

  async deleteAsync(brandingAppCode: string): Promise<boolean> {
    const URL = `/onboard/branding-app/${brandingAppCode}`
    const response = await this.apiService.deleteAsync<IApiResponse<any>, any>(URL);

    if (response && response.scResponse.code === 2000) {
      return true;
    }

    return false;
  }


}
